module.exports = __webpack_public_path__ + "media/images/athletes/142-acc4765d870fb28eef1e029e3e778d46.png";